<template>
    <div>
        <div style="padding: 10px 20px; font-size: 14px; color: #4E4E4E; background-color: white;">理赔信息</div>
        <div style="color: #666666; font-size: 12px; padding: 10px 20px; margin-top: 1px; background-color: white;">
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>被保险人</div>
                <div>{{info.applyName}}</div>
            </div>
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>出险时间</div>
                <div>{{info.outDate}}</div>
            </div>
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>出险人手机</div>
                <div>{{info.outPhone}}</div>
            </div>
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>出险人身份证</div>
                <div>{{info.applyIdCard}}</div>
            </div>
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>联络人姓名</div>
                <div>{{info.userName}}</div>
            </div>
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>联络人电话</div>
                <div>{{info.userPhone}}</div>
            </div>
            <div v-if="info.applyProdName" style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>理赔类型</div>
                <div>{{info.applyProdName}}</div>
            </div>
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>出险情况简述</div>
                <div style="flex: 1; margin-left: 20px;  text-align: right;">{{info.eventDepict}}</div>
            </div>
            <div v-if="info.applyAmount" style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>理赔金额</div>
                <div>{{info.applyAmount}}元</div>
            </div>
        </div>
        <div style="margin-top: 10px; padding: 10px 20px; font-size: 14px; color: #4E4E4E; background-color: white;">理赔进度</div>
        <div style="color: #666666; font-size: 12px; padding: 10px 20px; margin-top: 1px; background-color: white;">
            <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>理赔状态</div>
                <div>{{info.applyStatus === '0' ? "拒绝理赔" : info.applyStatus === '1' ? "正在处理" : "理赔成功" }}</div>
            </div>
            <div v-if="info.applyTime" style="display: flex; justify-content: space-between;margin-bottom: 20px;">
                <div>处理时间</div>
                <div>{{info.applyTime}}</div>
            </div>
            <div v-if="info.applyRemark" style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div>理赔备注</div>
                <div style="flex: 1; margin-left: 20px;">{{info.applyRemark}}</div>
            </div>
            <div>
                <div>益宝的工作人员会在1个工作日内联系您，跟进后续理赔事宜。
                    <br/> 如在理赔过程中对理赔事宜有任何异议，请通过以下方式联系我们：
                    <br/>在每个工作日的上午9:30-下午17:30，
                    <br/>您可以通过客服电话进行相关咨询：010-86464262
                    <br/>若不方便来电，您也可以通过邮箱和QQ等方式与我们联系：
                    <br/>ybjh@cn.yibaojihua.com；3066619203
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ClaimProgress",
        data() {
            return {
                id: this.$route.query.id || '',
                info: {}
            }
        },
        created() {
            this.$axios.get("/claim/getApply",{params: {applyId: this.id}}).then(res => {
                this.info = res.data
            }).catch(err => {
                console.log(err);
            })
        }
    }
</script>

<style scoped>

</style>
